import { render, staticRenderFns } from "./ContactQuery.vue?vue&type=template&id=c828af82&scoped=true&"
import script from "./ContactQuery.vue?vue&type=script&lang=js&"
export * from "./ContactQuery.vue?vue&type=script&lang=js&"
import style0 from "./ContactQuery.vue?vue&type=style&index=0&id=c828af82&prod&scoped=true&lang=css&"
import style1 from "./ContactQuery.vue?vue&type=style&index=1&id=c828af82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c828af82",
  null
  
)

export default component.exports